import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';

const languages = [
  { code: 'en', name: 'English', flag: '🇺🇸' },
  { code: 'pt-BR', name: 'Português', flag: '🇧🇷' },
];

export function LanguageSwitcher() {
  const { i18n } = useTranslation();

  const currentLanguage = languages.find((lang) => lang.code === i18n.language) || languages[0];
  const otherLanguage = languages.find((lang) => lang.code !== i18n.language) || languages[1];

  const toggleLanguage = () => {
    console.log('Current language:', i18n.language);
    console.log('Switching to:', otherLanguage.code);
    i18n.changeLanguage(otherLanguage.code);
    console.log('New language:', i18n.language);
  };

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={toggleLanguage}
      className="text-base hover:bg-gray-100 px-1.5 h-8 w-8 p-0"
      title={`Switch to ${otherLanguage.name}`}
    >
      {currentLanguage.flag}
    </Button>
  );
}
